<template>
  <b-tabs
    v-if="!loader"
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
  >

    <!-- general tab -->
    <b-tab active>

      <!-- title -->
      <template #title>
        <feather-icon
          icon="UserIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('General') }}</span>
      </template>

      <account-setting-general
        :general-data="user"
        @onFormSubmit="submit"
      />
    </b-tab>
    <!--/ general tab -->

    <!-- legal tab -->
    <b-tab>

      <!-- title -->
      <template #title>
        <feather-icon
          icon="UserCheckIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('Financial information') }}</span>
      </template>

      <account-setting-legal
        :general-data="user"
        @onFormSubmit="submit"
      />
    </b-tab>
    <!--/ legal tab -->

    <!-- change password tab -->
    <b-tab>

      <!-- title -->
      <template #title>
        <feather-icon
          icon="LockIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('Change Password') }}</span>
      </template>

      <account-setting-password @onFormSubmit="submit" />
    </b-tab>
    <!--/ change password tab -->

    <!-- affiliate tab -->
    <b-tab>

      <!-- title -->
      <template #title>
        <feather-icon
          icon="LinkIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('Affiliate') }}</span>
      </template>

      <account-setting-affiliate :user="user" />
    </b-tab>
    <!--/ affiliate tab -->
  </b-tabs>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import AccountSettingGeneral from '../../components/users/account-setting/AccountSettingGeneral.vue'
import AccountSettingLegal from '../../components/users/account-setting/AccountSettingLegal.vue'
import AccountSettingPassword from '../../components/users/account-setting/AccountSettingPassword.vue'
import AccountSettingAffiliate from '../../components/users/account-setting/AccountSettingAffiliate.vue'
import { getUserData, permissionsResolver } from '../../auth/utils'

export default {
  components: {
    BTabs,
    BTab,
    AccountSettingGeneral,
    AccountSettingLegal,
    AccountSettingPassword,
    AccountSettingAffiliate,
  },
  props: {
    id: {
      type: [String, Number],
      default: () => '',
    },
  },
  data() {
    return {
      loader: false,
      user: this.id ? {} : getUserData(),
    }
  },
  created() {
    if (this.id) this.getData()
  },
  methods: {
    getData() {
      this.loader = true
      this.$http.get(`users/${this.id}`).then(({ data }) => {
        this.user = data
        this.loader = false
      })
    },
    submit(form) {
      const formData = new FormData()
      Object.keys(form).forEach(name => {
        const value = form[name]
        if (value !== null && value !== undefined) formData.append(name, value)
      })
      formData.append('_method', 'PUT')
      this.$http.post(`users/${this.user.id}`, formData).then(({ data }) => {
        this.user = data
        localStorage.setItem('userData', JSON.stringify(this.user))
        const permissions = permissionsResolver(this.user.permissions)
        permissions.push({
          action: 'manage',
          subject: 'all',
        })
        this.$ability.update(permissions)
      })
    },
  },
}
</script>
